const getBaseUrl = () => {
  const stage = process.env.REACT_APP_STAGE;
  return `https://${stage === "prod" ? "api" : stage}.axle.insure/automatic`;
};

export const getValidationResults = async (token: string) => {
  const response = await fetch(`${getBaseUrl()}/validations/results`, {
    method: "GET",
    headers: { Authorization: token },
  });

  const body = await response.json();

  if (!response.ok) {
    throw new Error(body.message || "Failed to load validation results");
  }

  return body.data;
};

